module.exports = __webpack_public_path__ + "img/web-link.b522d436.png";